export default __webpack_public_path__ + "static/media/third_person.bbb238c2.svg";